<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="tw-col-span-2 md:tw-col-span-1">
      <mat-label>Cantidad liberada</mat-label>
      <input
        [max]="maxQuantity"
        [min]="0"
        formControlName="quantity"
        matInput
        name="quantity"
        required
        type="number"
      />
      <mat-hint>Maximo: {{ maxQuantity }}</mat-hint>
    </mat-form-field>
    <mat-form-field appearance="outline" class="tw-col-span-2 md:tw-col-span-1">
      <mat-label>Turno</mat-label>
      <mat-select formControlName="shiftId">
        <mat-option *ngFor="let op of shifts" [value]="op.id">
          {{ op.title }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field
      *ngIf="showOperators"
      appearance="outline"
      class="tw-col-span-2"
    >
      <mat-label>Operador</mat-label>
      <mat-select formControlName="operatorId" aria-hidden="false">
        <mat-option>
          <ngx-mat-select-search
            formControlName="searchOperator"
            placeholderLabel="Buscar..."
            noEntriesFoundLabel="Sin resultados"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let op of operators$ | async" [value]="op.id">
          {{ op.fullName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="tw-col-span-2">
      <mat-label>Scrap</mat-label>
      <input formControlName="scrap" matInput type="number" [min]="0"/>
    </mat-form-field>
    <ng-container>
      <app-form-scrap-reasons
        [class.tw-hidden]="!showReasons"
        class="tw-col-span-2"
      ></app-form-scrap-reasons>
    </ng-container>
  </form>
</div>

<div mat-dialog-actions>
  <button (click)="onClickClose()" mat-raised-button class="app-btn-close">
    Cerrar
  </button>
  <button
    (click)="onClickSave()"
    [disabled]="!form.valid || disable"
    mat-raised-button
    class="app-btn-save"
  >
    Guardar cambios
  </button>
</div>
